import { Component, OnInit } from '@angular/core';
import { ReportService } from './../../../admin/services/report.service';
import { environment } from 'src/environments/environment';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-bonos-clientes-comercial',
  templateUrl: './bonos-clientes-comercial.component.html',
  styleUrls: ['./bonos-clientes-comercial.component.css'],
})
export class BonosClientesComercialComponent implements OnInit {
  datePickerConfig: Partial<BsDatepickerConfig>;

  constructor(private comercial: ReportService) {
    this.datePickerConfig = Object.assign(
      {},
      { containerClass: 'theme-blue', dateInputFormat: 'DD/MM/YYYY' }
    );
  }

  comercialArray: any = [];

  showLoading: boolean = true;
  page = 1;
  limit = 1;
  count = 0;
  token = window.localStorage.getItem('token');
  date_created_after;
  date_created_before;
  search;

  ngOnInit() {
    this.showLoading = true;

    this.getComercial();
  }

  getComercial() {
    let initYear =
      (this.date_created_after && this.date_created_after.getFullYear()) || '';

    let initMonth =
      (this.date_created_after &&
        ('0' + (this.date_created_after.getMonth() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let initDay =
      (this.date_created_after &&
        ('0' + this.date_created_after.getDate()).toString().slice(-2)) ||
      '';

    let endYear =
      (this.date_created_before && this.date_created_before.getFullYear()) ||
      '';

    let endMonth =
      (this.date_created_before &&
        ('0' + (this.date_created_before.getMonth() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let endDay =
      (this.date_created_before &&
        ('0' + this.date_created_before.getDate()).toString().slice(-2)) ||
      '';

    let init =
      (this.date_created_after && initYear + '-' + initMonth + '-' + initDay) ||
      '';

    let end =
      (this.date_created_before && endYear + '-' + endMonth + '-' + endDay) ||
      '';
    this.comercial
      .getComercialRetail(init, end, this.search)
      .toPromise()
      .then((data) => {
        console.log(data);
        this.limit = Math.ceil(data['count'] / 10);
        this.count = data['count'];
        this.comercialArray = data['results'];
        this.showLoading = false;
      })
      .catch((error) => console.log(error));
  }

  xslRetailComercial() {
    let initYear =
      (this.date_created_after && this.date_created_after.getFullYear()) || '';

    let initMonth =
      (this.date_created_after &&
        ('0' + (this.date_created_after.getMonth() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let initDay =
      (this.date_created_after &&
        ('0' + this.date_created_after.getDate()).toString().slice(-2)) ||
      '';

    let endYear =
      (this.date_created_before && this.date_created_before.getFullYear()) ||
      '';

    let endMonth =
      (this.date_created_before &&
        ('0' + (this.date_created_before.getMonth() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let endDay =
      (this.date_created_before &&
        ('0' + this.date_created_before.getDate()).toString().slice(-2)) ||
      '';

    let init =
      (this.date_created_after && initYear + '-' + initMonth + '-' + initDay) ||
      '';

    let end =
      (this.date_created_before && endYear + '-' + endMonth + '-' + endDay) ||
      '';
    window.open(
      environment.xslComercialRetail +
        '?token=' +
        this.token +
        '&start=' +
        init +
        '&end=' +
        end +
        '&search=' +
        this.search
    );
  }
}
